import { useContext } from 'react';

import { BrandingContext } from '../../contexts/BrandingContext';

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (context === undefined) {
    throw new Error('useBranding must be used within an BrandingProvider');
  }
  return context;
};
